
<template>
<v-app>
  <v-app-bar app dark class="navbar-bg blue darken-4" v-if="this.$router.currentRoute.path != '/login'">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-bind="attrs" v-on="on"></v-app-bar-nav-icon>
      </template>
      <span>منوی سیستم</span>
    </v-tooltip>
    <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
    <v-toolbar-title>سیستم حسابداری کیان</v-toolbar-title>

    <v-spacer />

    <v-toolbar-title>{{`(${myDateTime().dayOfWeek}) ${myDateTime().date}`}}</v-toolbar-title>

    <v-spacer />

    <v-toolbar-title>{{` ${user_name}`}}</v-toolbar-title>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="editUserPassword" v-bind="attrs" v-on="on">
          <v-icon>mdi-account-lock</v-icon>
        </v-btn>
      </template>
      <span>ویرایش رمز عبور</span>
    </v-tooltip>

    <!-- <v-btn icon @click="editUserName">
      <v-icon>mdi-account-details</v-icon>
    </v-btn> -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="exit" v-bind="attrs" v-on="on">
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </template>
      <span>خروج</span>
    </v-tooltip>

    <!-- <v-btn to="/login" text>Login</v-btn> -->
  </v-app-bar>
  <v-navigation-drawer app right v-model="drawer">

    <!-- only set shortkey  -->
    <div v-for="item in menus.items" :key="item.name" v-show="false">
      <span v-if="!item.subs">
        <v-btn v-shortkey="item.shortkey" @shortkey="actionkey(item.shortkey, item.route)">{{item.title}}</v-btn>
      </span>
      <span v-if="item.subs">
        <v-btn v-for="sub in item.subs" :key="sub.name" link v-shortkey="sub.shortkey" @shortkey="actionkey(sub.shortkey, sub.route)" >
        </v-btn>
      </span>
    </div>
    <!--  -->

    <v-list-item>
      <v-list-item-content class="px-2 py-5">
        <v-list-item-title class="text-capitalize" align="right">
          <h2>منوی سیستم</h2>
        </v-list-item-title>
        <!-- <v-list-item-subtitle> Using Navigation drawers</v-list-item-subtitle> -->
      </v-list-item-content>
    </v-list-item>
    <!-- <v-divider></v-divider> -->

    <v-list dense nav v-for="item in menus.items" :key="item.name">
      <v-list-group :value="false" color="blue">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item v-for="sub in item.subs" :key="sub.name" link v-on:click="actionkey(sub.shortkey, sub.route, click=true)" color="blue">
          <v-list-item-icon>
            <v-icon>{{ sub.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{`${sub.title}(${String(sub.shortkey).replace(',', '+').toUpperCase()})`}}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>

  </v-navigation-drawer>

  <v-main class="scrollable pt-0 mt-16">
    <v-container fluid>
      <v-row align="center" class="list px-1 mx-auto">
        <v-col cols="12" sm="12" class="elevation-3">
          <!-- <v-card class="mx-auto mypadding" tile> -->

          <router-view></router-view>

          <!-- </v-card> -->
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</v-app>
</template>

<script>
// @ is an alias to /src
import homeMixin from '../mixins/Home'

export default {
  name: 'HomeView',
  mixins: [homeMixin],
  methods: {
    editUserName() {
      let path = this.$router.currentRoute.path
      if (path !== `/users/edit/${this.user_id}` && path !== `/users/password/${this.user_id}`) {
        this.$router.push({
          path: `/users/edit/${this.user_id}`
        })
      }
    },
    editUserPassword() {
      let path = this.$router.currentRoute.path
      if (path !== `/users/edit/${this.user_id}` && path !== `/users/password/${this.user_id}`) {
        this.$router.push({
          path: `/users/password/${this.user_id}`
        })
      }
    },
    exit() {
      if (window.confirm(`آیا مایل به خروج از سیستم هستید؟`) === true) {
        this.$store.dispatch("logout")
      }
    },
  },
  created() {
    let user = JSON.parse(sessionStorage.getItem('auth'))
    this.menus = JSON.parse(sessionStorage.getItem('menus'))
    this.user_name = `${user.first_name} ${user.last_name}`
    this.user_id = user._id
  },
  mounted() {
    document.title = 'سیستم حسابداری کیان';
  },
  data: () => ({
    selectedItem: 0,
    drawer: false,
    //
    user_id: null,
    user_name: null,
    menus: null,
  }),
}
</script>
<style lang="scss">
.v-autocomplete {
    font-size: 20px;
}
.v-text-field {
    font-size: 20px;
}
</style>
